import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { toast } from "react-toastify";
import { get } from "lodash";
import MBOForm from "./MBOForm";
import { isMobile } from "react-device-detect";

function HrView(props) {
  const rowData = props.rowData;

  console.log("Props", props);
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();
  const [dynamicFieldsError, setDynamicFieldsError] = useState("");

  const [formData, setFormData] = useState({
    target1: rowData.quarter_1.target,
    target2: rowData.quarter_2.target,
    target3: rowData.quarter_3.target,
    target4: rowData.quarter_4.target,
    year: "2024",
  });
  const [mboTerms, setMboTerms] = useState({
    sales_planning: "",
    key_sales: "",
    key_market_research: "",
    key_reporting: "",
    key_database_maintenance: "",
    key_etiquettes_conduct: "",
    key_technical_expertise: "",
  });

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const availableYears = [currentYear, currentYear + 1, currentYear + 2];
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [terms, setTerms] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [distributorsList, setDistributorsList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [alignmentClass, setAlignmentClass] = useState(
    "border-end text-center"
  );

  const tasks = [
    "Attend product training sessions to enhance product knowledge.",
    "Maintaining progressive relations with clients.",
    "Taking team suggestions for areas of lacking, and taking guidance from managers.",
    "Managing product mix in a manner where all products are sold as per the market potential of your area.",
    "Maintaining good relations with all the team members.",
    "Daily reporting to your manager with necessary information.",
    "Maintaining the budget ratio for all departments.",
  ];

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const isHR = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Hr_permissions"
  );

  const isSuperAdmin = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Super_Admin_permissions"
  );

  const fields = [
    {
      label: "Name",
      value: `${rowData?.name}`,
    },
    {
      label: "Reporting Manager Name",
      value: rowData?.reporting_manager ? rowData?.reporting_manager : "",
    },
    {
      label: "Sr. RSM/RSM",
      value:
        rowData?.designation === "Regional Sales Manager" ||
        rowData?.designation === "Sr. Regional Sales Manager"
          ? "Yes"
          : "No",
    },
    {
      label: "Date",
      value: moment(rowData.joining_date).format("DD-MM-YYYY"),
    }, // Current Date
    { label: "Location", value: rowData?.location || "Unknown" },
  ];

  useEffect(() => {
    getEmpDetails();
    getMboTerms();
  }, []);

  useEffect(() => {
    // Update the alignment class based on whether it's mobile or not
    if (isMobile) {
      setAlignmentClass(""); // No text-center on mobile devices
    }
  }, []); // This runs once after the component mounts

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getEmpDetails = () => {
    utils
      .callAPI("get", `/sales/emp_details`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setUserDetails(res);
        } else {
          setUserDetails([]);
        }
      })
      .catch((err) => {
        setUserDetails([]);
      });
  };

  const getTerms = (id) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", id === "none" ? "" : id);

    utils
      .callAPI("post", `/sales/getQuotationTerms`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: res.contents, // Assuming res is the terms string received from API
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: "", // Set to default if res is undefined or empty
          }));
        }
      })
      .catch((err) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          termsAndConditions: "", // Set to default if API call fails or res is undefined
        }));
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Regular expression to check if the input contains only digits
    const isOnlyDigits = /^\d*$/.test(value); // Allows an empty value or digits only

    // Only update formData if the value contains only digits
    if (isOnlyDigits) {
      setFormData({
        ...formData,
        [name]: value, // Update the value if it contains only digits
      });
    }
  };

  const handleBackClick = () => {
    const propdata = {
      mode: isHR || isSuperAdmin ? "HrView" : "HrView",
      rowData: rowData,
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  const getMboTerms = () => {
    utils
      .callAPI("get", `/sales/getMboTerms`)
      .then((res) => {
        if (typeof res !== "undefined") {
          console.log("resssss", res);
          setMboTerms(res);
          // console.log(
          //   "Yeh hai company",
          //   res.result.map((company) => company.companyName)
          // );
        } else {
          setMboTerms({});
        }
      })
      .catch((err) => {
        setMboTerms({});
      });
  };

  const caluclateTotal = () => {
    const { target1, target2, target3, target4 } = formData;

    return (
      (parseFloat(target1) || 0) +
      (parseFloat(target2) || 0) +
      (parseFloat(target3) || 0) +
      (parseFloat(target4) || 0)
    );
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const splitContent = (content) => {
    console.log("Here is the content", content);
    if (content) {
      return content.split("<br />\n");
    }
    return [];
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col className=" border-top border-start border-end p-2 text-center">
                <h4>Vura MBO Form</h4>
              </RB.Col>
            </RB.Row>

            {fields.map((field, index) => (
              <RB.Row key={index} className=" border border-bottom-0">
                <RB.Col
                  className={`px-2 py-1 py-md-2  ${alignmentClass}`}
                  md={4}
                >
                  {field.label}
                </RB.Col>
                <RB.Col className="px-2 py-1  py-md-2" md={8}>
                  {field.value}
                </RB.Col>
              </RB.Row>
            ))}

            <RB.Row>
              <RB.Col className=" border-top border-start border-end p-2 text-center">
                <h4 className="mb-0">Sales Target</h4>
              </RB.Col>
            </RB.Row>

            <RB.Row className="border border-bottom-0">
              <RB.Col
                className={` p-1  d-flex justify-content-center align-items-center ${alignmentClass}`}
                md={4}
              >
                <h4>Period</h4>
              </RB.Col>
              <RB.Col className="  text-center p-1" md={8}>
                <h4>Target in Values</h4>
                <p className="mb-0">
                  (Put values in lakhs only, e.g. - if your target is 1 CR, you
                  have to write 100)
                </p>
              </RB.Col>
            </RB.Row>

            <MBOForm
              formData={formData}
              handleInputChange={handleInputChange}
              isMobile={isMobile}
              isMboView={true}
            />
            <RB.Row className="border">
              <RB.Col
                className={`p-2 p-md-4  d-flex justify-content-md-center align-items-md-center ${alignmentClass}`}
                md={4}
              >
                Yearly Target
              </RB.Col>
              <RB.Col
                className="   text-left d-flex  align-items-center p-1  ps-2"
                md={8}
              >
                {rowData?.yearly ? rowData.yearly : caluclateTotal()}
              </RB.Col>
            </RB.Row>

            <RB.Row className="border border-top-0 text-center">
              <RB.Col
                className={`p-1 p-md-1  d-flex justify-content-center align-items-center `}
              >
                <h6 className="mb-0">
                  {" "}
                  Suggestions for better Sales Planning:
                </h6>
              </RB.Col>
            </RB.Row>

            <RB.Row className="border border-top-0">
              {" "}
              <RB.Col className="">
                <div
                  dangerouslySetInnerHTML={{ __html: mboTerms.sales_planning }}
                />
              </RB.Col>
            </RB.Row>

            <RB.Row className="mt-4 border">
              <RB.Col md={12} className="text-center">
                <h6 className="mb-0">Key Responsibility Areas (KRA)</h6>
                <span>
                  in a broader explanantion, which is considered for appraisal
                  and Increment process:
                </span>
              </RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Sales:
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top"
              ></RB.Col>
              {splitContent(mboTerms.key_sales)?.map((item, index) => (
                <RB.Col key={index} md={12} className="border-top">
                  {item}
                </RB.Col>
              ))}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Market Research
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
              {splitContent(mboTerms.key_market_research)?.map(
                (item, index) => (
                  <RB.Col key={index} md={12} className="border-top">
                    {item}
                  </RB.Col>
                )
              )}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Reporting
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
              {splitContent(mboTerms.key_reporting)?.map((item, index) => (
                <RB.Col key={index} md={12} className="border-top">
                  {item}
                </RB.Col>
              ))}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Database Maintenance
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
              {splitContent(mboTerms.key_database_maintenance)?.map(
                (item, index) => (
                  <RB.Col key={index} md={12} className="border-top">
                    {item}
                  </RB.Col>
                )
              )}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Etiquettes and Conduct
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
              {splitContent(mboTerms.key_etiquettes_conduct)?.map(
                (item, index) => (
                  <RB.Col key={index} md={12} className="border-top">
                    {item}
                  </RB.Col>
                )
              )}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>

              <RB.Col md={12} className="border-top">
                <span className="fw-bold text-decoration-underline fs-6">
                  Technical Expertise
                </span>
              </RB.Col>
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
              {splitContent(mboTerms.key_technical_expertise)?.map(
                (item, index) => (
                  <RB.Col key={index} md={12} className="border-top">
                    {item}
                  </RB.Col>
                )
              )}
              <RB.Col
                style={{ padding: "0.7rem" }}
                className="border-top "
              ></RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default HrView;
